<script lang="ts">
  // Exports
  export let key: string;
</script>

<p class="mb-0" id={key}>
  Check the info to learn how to add this functionality in Webflow.
</p>
